export default __webpack_public_path__ + "static/media/minus_icon.603811c7.png";